module.exports = __webpack_public_path__ + "static/media/BlueBanner.4178c98a.png";